import { CrescendoIcon, LogoIconV2 } from "@/shared/icons";

export const getLogo = () => {
  switch (window.__RUNTIME_CONFIG__.INSTALLATION_TYPE ?? "PEOPLE") {
    case "CRESCENDO": {
      return <CrescendoIcon />;
    }
    case "PEOPLE": {
      return <LogoIconV2 />;
    }
    default: {
      return <LogoIconV2 />;
    }
  }
};
